import { IApiError } from '@frontend/request';

import {
  IAnnouncement,
  IAsset,
  IAssetParams,
  ICompany,
  IContact,
  IFeatureAnnouncement,
  configAPI
} from '@aqx-core/common/api/config';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';
import { i18n } from '@aqx-core/common/i18n';

class ConfigAPIController {
  private companyProfileAC?: AbortController;

  public getAnnoucementList = async (callbacks: IAPIControllerCallbacks<IAnnouncement[]>) => {
    try {
      const { result } = await configAPI.annoncements();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getAssetList = async (params: IAssetParams, callbacks: IAPIControllerCallbacks<IAsset[]>) => {
    try {
      const { result } = await configAPI.assets(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getCompanyProfile = async (callbacks: IAPIControllerCallbacks<ICompany>) => {
    try {
      this.companyProfileAC?.abort();
      this.companyProfileAC = new AbortController();

      const { result } = await configAPI.companyProfile(this.companyProfileAC.signal);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getCompanyProfileAfterLogin = async (callbacks: IAPIControllerCallbacks<ICompany>) => {
    try {
      const { result } = await configAPI.companyProfileAfterLogin();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getCompanyContact = async (callbacks: IAPIControllerCallbacks<IContact>) => {
    try {
      const { result } = await configAPI.companyContact();
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public fetchFeatureAnnouncements = async (callbacks: IAPIControllerCallbacks<IFeatureAnnouncement[]>) => {
    try {
      const { result } = await configAPI.fetchFeatureAnnouncements({ language: i18n.language });
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public markFeatureAnnouncementAsSeen = async (id: string, callbacks?: IAPIControllerCallbacks<void>) => {
    try {
      const { result } = await configAPI.markFeatureAnnouncementAsSeen({ id });
      callbacks?.onSuccess(result);
    } catch (error) {
      callbacks?.onError(error as IApiError);
    } finally {
      callbacks?.onFinally?.();
    }
  };
}

export const configAPIController = new ConfigAPIController();
